import { render, staticRenderFns } from "./recall-query.vue?vue&type=template&id=406333d1&scoped=true"
import script from "./recall-query.vue?vue&type=script&lang=js"
export * from "./recall-query.vue?vue&type=script&lang=js"
import style0 from "./recall-query.vue?vue&type=style&index=0&id=406333d1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406333d1",
  null
  
)

export default component.exports